var _mask, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1719_43328",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 4.63789C31.5 2.07646 33.5868 -0.0339468 36.1222 0.330355C40.6489 0.980776 45.0055 2.58202 48.8976 5.04869C54.1011 8.34646 58.2601 13.0552 60.8899 18.6262C63.5198 24.1972 64.512 30.4008 63.7512 36.5141C62.9903 42.6275 60.5075 48.3986 56.5923 53.1549C52.6771 57.9113 47.4907 61.4569 41.6376 63.3785C35.7844 65.3001 29.5057 65.5185 23.5332 64.0084C17.5607 62.4983 12.1403 59.3217 7.90401 54.849C4.73531 51.5035 2.32665 47.5359 0.818381 43.2187C-0.0263991 40.8005 1.6436 38.347 4.15729 37.8547C6.67098 37.3624 9.06596 39.0299 10.0471 41.396C11.1281 44.0027 12.6802 46.4028 14.6385 48.4704C17.6658 51.6666 21.5391 53.9365 25.807 55.0156C30.0749 56.0948 34.5616 55.9386 38.7442 54.5655C42.9268 53.1923 46.633 50.6587 49.4307 47.2598C52.2285 43.861 54.0027 39.737 54.5464 35.3685C55.0901 31 54.381 26.5669 52.5018 22.5859C50.6225 18.6049 47.6505 15.2401 43.9322 12.8835C41.5267 11.3591 38.8731 10.2972 36.1072 9.73736C33.5967 9.22921 31.5 7.19933 31.5 4.63789Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 4.63789C31.5 2.07646 33.5868 -0.0339468 36.1222 0.330355C40.6489 0.980776 45.0055 2.58202 48.8976 5.04869C54.1011 8.34646 58.2601 13.0552 60.8899 18.6262C63.5198 24.1972 64.512 30.4008 63.7512 36.5141C62.9903 42.6275 60.5075 48.3986 56.5923 53.1549C52.6771 57.9113 47.4907 61.4569 41.6376 63.3785C35.7844 65.3001 29.5057 65.5185 23.5332 64.0084C17.5607 62.4983 12.1403 59.3217 7.90401 54.849C4.73531 51.5035 2.32665 47.5359 0.818381 43.2187C-0.0263991 40.8005 1.6436 38.347 4.15729 37.8547C6.67098 37.3624 9.06596 39.0299 10.0471 41.396C11.1281 44.0027 12.6802 46.4028 14.6385 48.4704C17.6658 51.6666 21.5391 53.9365 25.807 55.0156C30.0749 56.0948 34.5616 55.9386 38.7442 54.5655C42.9268 53.1923 46.633 50.6587 49.4307 47.2598C52.2285 43.861 54.0027 39.737 54.5464 35.3685C55.0901 31 54.381 26.5669 52.5018 22.5859C50.6225 18.6049 47.6505 15.2401 43.9322 12.8835C41.5267 11.3591 38.8731 10.2972 36.1072 9.73736C33.5967 9.22921 31.5 7.19933 31.5 4.63789Z",
    stroke: "url(#paint0_angular_1719_43328)",
    strokeWidth: 18,
    mask: "url(#path-1-inside-1_1719_43328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_1719_43328",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.0417 33.0417) rotate(-175.073) scale(31.5332 31.7722)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0246283,
    stopColor: "#7230ED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0799026,
    stopColor: "#7B35EE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429289,
    stopColor: "#4B1BE7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705517,
    stopColor: "#2406E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.5c2ff1a8fed7699d94c0a68250713986.svg";
export { ForwardRef as ReactComponent };